// Products under $100 are phone order only: take Add to Cart out of the wishlist popup for them.
(function ($) {
  var limit = 100;
  var list = document.querySelector('#wishlistTableList tbody');
  if (!list || !window.MutationObserver) return;

  var markRows = function () {
    // The theme wraps each row in its own table inside the list, so search all descendants
    $(list).find('tr').has('.special-price').each(function () {
      var $row = $(this);
      if ($row.data('phoneOrderChecked')) return;
      var price = parseFloat($row.find('.special-price').text().replace(/[^0-9.]/g, ''));
      if (isNaN(price)) return;
      $row.data('phoneOrderChecked', true);
      if (price < limit) {
        $row.find('.add-cart-wishlist, .add-to-cart, .product-qty .input-box').remove();
        $row.find('.product-qty').append('<p class="phone-order-note">Phone order only: call <a href="tel:18668054328">1-866-805-4328</a></p>');
      }
    });
  };

  new MutationObserver(markRows).observe(list, { childList: true, subtree: true });
})(jQuery);
